import { Navigate } from 'react-router-dom';
import {
  useHasAnalyticsDashboardsBills,
  useHasAnalyticsDashboardsPurchases,
  useHasAnalyticsDashboardsSales,
} from '~/hooks/useFeatureFlag';
import { RouteConfig } from '~/routes/routeConfig';
import { UserRole } from '~/types/company';

const AnalyticsIndexRedirect: React.FC = () => {
  const hasPurchases = useHasAnalyticsDashboardsPurchases([UserRole.ENTREPRENEUR]);
  const hasSales = useHasAnalyticsDashboardsSales([UserRole.ENTREPRENEUR]);
  const hasBills = useHasAnalyticsDashboardsBills([UserRole.ENTREPRENEUR]);

  if (hasPurchases) return <Navigate to={RouteConfig.AnalyticsPurchases.buildLink()} replace />;
  if (hasSales) return <Navigate to={RouteConfig.AnalyticsSales.buildLink()} replace />;
  if (hasBills) return <Navigate to={RouteConfig.AnalyticsBills.buildLink()} replace />;

  return <Navigate to={RouteConfig.AppRoot.buildLink()} replace />;
};

export default AnalyticsIndexRedirect;
